import { cn } from "@/utils";
import * as Popover from "@radix-ui/react-popover";
import { useEffect, useState } from "react";
import { FaSortDown } from "react-icons/fa6";

export function FontSizeSelect({
  editor,
  className,
}: {
  editor: any;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  const [currentSize, setCurrentSize] = useState(14);
  const sizes = [12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48];

  useEffect(() => {
    if (!editor) return;

    const update = () => {
      const size = editor.getAttributes("textStyle")?.fontSize || "14";
      setCurrentSize(parseInt(size, 10) || 14);
    };

    // Lắng nghe khi selection thay đổi
    editor.on("selectionUpdate", update);
    editor.on("transaction", update);

    // cleanup khi unmount
    return () => {
      editor.off("selectionUpdate", update);
      editor.off("transaction", update);
    };
  }, [editor]);

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      {/* Trigger */}
      <Popover.Trigger>
        <div
          onMouseDown={(e) => {
            // KHÔNG cho editor mất focus
            e.preventDefault();
          }}
          className={cn("text-sm text-light_secondary flex gap-x-1", className)}
        >
          <p className="w-6">{currentSize}</p>
          <FaSortDown className="w-5" />
        </div>
      </Popover.Trigger>

      {/* Content */}
      <Popover.Portal>
        <Popover.Content
          side="bottom"
          align="start"
          className="z-50 bg-white border rounded shadow-md py-1"
          onOpenAutoFocus={(e) => e.preventDefault()} // Giữ focus editor
          onCloseAutoFocus={(e) => e.preventDefault()} // Không auto-focus lại trigger
        >
          {sizes.map((size) => (
            <button
              type="button"
              key={size}
              onMouseDown={(e) => {
                // ⚠️ NGĂN BLUR trước khi chọn
                e.preventDefault();
              }}
              onClick={() => {
                setCurrentSize(size);
                editor.chain().focus().setFontSize(`${size}px`).run();
                setOpen(false);
              }}
              className={`block w-full text-left px-3 py-1 hover:bg-gray-100 ${
                size === currentSize ? "bg-gray-100 font-semibold" : ""
              }`}
            >
              {size}
            </button>
          ))}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
